import { API_BASE } from "../config";

function trim(value) {
  return String(value || "").trim();
}

function stripTrailingSlashes(value) {
  return trim(value).replace(/\/+$/, "");
}

function looksLikeCanonicalStoragePath(value) {
  const normalized = trim(value).replace(/^\/+/, "");
  if (!normalized) return false;
  if (normalized.startsWith("uploads/")) return false;

  const knownPrefixes = [
    "logos/",
    "brand/",
    "videos/",
    "tasks/",
    "content/",
    "question-images/",
    "images/",
    "books/",
  ];

  if (knownPrefixes.some((prefix) => normalized.startsWith(prefix))) {
    return true;
  }

  return /^[^/?#]+\/[^?#]+$/.test(normalized) && /\.[a-z0-9]{2,8}$/i.test(normalized);
}

function joinUrl(base, value) {
  const safeBase = stripTrailingSlashes(base);
  const safeValue = trim(value).replace(/^\/+/, "");
  if (!safeBase) return safeValue ? `/${safeValue}` : "";
  if (!safeValue) return safeBase;
  return `${safeBase}/${safeValue}`;
}

function buildMediaObjectUrl(base, value) {
  const safeBase = stripTrailingSlashes(base);
  const safeValue = trim(value).replace(/^\/+/, "");
  if (!safeValue) return "";
  if (!safeBase) return `/media/object?path=${encodeURIComponent(safeValue)}`;
  return `${safeBase}/media/object?path=${encodeURIComponent(safeValue)}`;
}

export function resolveMediaUrl(value, options = {}) {
  const src = trim(value);
  if (!src) return "";

  if (/^(?:https?:)?\/\//i.test(src) || src.startsWith("data:") || src.startsWith("blob:")) {
    return src;
  }

  const apiBase = stripTrailingSlashes(options.apiBase || API_BASE);
  if (src.startsWith("/uploads/")) {
    return buildMediaObjectUrl(apiBase, src);
  }

  if (src.startsWith("/")) {
    return apiBase ? `${apiBase}${src}` : src;
  }

  if (looksLikeCanonicalStoragePath(src)) {
    return buildMediaObjectUrl(apiBase, src);
  }

  return joinUrl(apiBase, src);
}

export function pickUploadedStoragePath(result, fallbackKeys = []) {
  const response = result && typeof result === "object" ? result : {};
  const dynamicFallbacks = Array.isArray(fallbackKeys) ? fallbackKeys : [];
  const candidates = [
    response.storage_path,
    response.storagePath,
    ...dynamicFallbacks.map((key) => response?.[key]),
    response.path,
    response.logo_url,
    response.video_url,
    response.public_url,
    response.publicUrl,
  ];

  for (const candidate of candidates) {
    const value = trim(candidate);
    if (value) return value;
  }

  return "";
}
